const lbTripOptionsModal = angular.module('app.lbTripOptionsModal', [
  require('../lbLocationSelect').name
]);

lbTripOptionsModal.controller('lbTripOptionsModalCtrl', require('./lbTripOptionsModalCtrl'));
lbTripOptionsModal.component('lbTripOptionsModal', require('./lbTripOptionsModal'));
lbTripOptionsModal.controller('lbTripOptionsHotelFormCtrl', require('./lbTripOptionsHotelFormCtrl'));
lbTripOptionsModal.component('lbTripOptionsHotelForm', require('./lbTripOptionsHotelForm'));
lbTripOptionsModal.controller('lbTripOptionsHotelFormItemCtrl', require('./lbTripOptionsHotelFormItemCtrl'));
lbTripOptionsModal.component('lbTripOptionsHotelFormItem', require('./lbTripOptionsHotelFormItem'));
lbTripOptionsModal.controller('lbTripOptionsCarFormCtrl', require('./lbTripOptionsCarFormCtrl'));
lbTripOptionsModal.component('lbTripOptionsCarForm', require('./lbTripOptionsCarForm'));
lbTripOptionsModal.controller('lbTripOptionsCarFormItemCtrl', require('./lbTripOptionsCarFormItemCtrl'));
lbTripOptionsModal.component('lbTripOptionsCarFormItem', require('./lbTripOptionsCarFormItem'));

export default lbTripOptionsModal;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/index.js